import { render } from "./DesignFacility.vue?vue&type=template&id=6b398806&scoped=true"
import script from "./DesignFacility.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignFacility.vue?vue&type=script&setup=true&lang=js"

import "./DesignFacility.vue?vue&type=style&index=0&id=6b398806&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b398806"],['__file',"src/pages/scada/DesignFacility.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b398806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b398806', __exports__)) {
    console.log('reload')
    api.reload('6b398806', __exports__)
  }
  
  module.hot.accept("./DesignFacility.vue?vue&type=template&id=6b398806&scoped=true", () => {
    console.log('re-render')
    api.rerender('6b398806', render)
  })

}


export default __exports__